import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { H4 } from '../styles';
import { colors } from '../../styles/variables/colors';
import { breakpoints } from '../../styles/variables/breakpoints';

export const StyledVotesList = styled.div`
  margin-top: 32px;
`;

export const StyledVotesListContent = styled.div`
  display: grid;
`;

export const StyledH4 = styled(H4)`
  &:first-of-type {
    margin-top: 0;
  }

  margin: 16px 0 32px 0;
`;

export const StyledVoteIcon = styled.div`
  margin-right: 16px;
`;

export const StyledVoteBox = styled(Link)`
  padding: 24px 32px;
  margin-bottom: 16px;
  background-color: ${colors.lightGrey};
  display: flex;
  align-items: center;
  font-size: 16px;
  text-decoration: none;
  color: black;

  @media ${breakpoints.width768} {
    align-items: flex-start;
    padding: 16px 20px;
  }

  &:hover,
  &:active {
    text-decoration: none;
    color: black;
  }
`;
